import * as React from "react";

interface INextYearAutoRenewalBannerProps {
    setPerformRenewal: (value: boolean) => void;
    turnOnNextYearRenewal: () => void;
}

interface INextYearAutoRenewalBannerState {
    displayInfoMessage: boolean;
}

export class NextYearAutoRenewalBanner extends React.Component<INextYearAutoRenewalBannerProps, INextYearAutoRenewalBannerState> {

    constructor(props: INextYearAutoRenewalBannerProps) {
        super(props);
    }

    public render() {
        return (
            <div className="banner banner-info">
                <div className="banner-content auto-renew-banner">
                    <div className="banner-text">
                        <p><strong>You have opted out of auto-renewal.</strong><br/>
                            Save time and stay covered next year. No strings.</p>
                    </div>
                    <div className="opt-in-auto-renew-link">
                        <div className="opt-in-auto-renew-btn">
                            <a onClick={() => this.props.turnOnNextYearRenewal()}
                               className="btn btn-text">
                                Opt in to auto-renew
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/banners/NextYearAutoRenewalBanner.tsx